module.exports = __webpack_public_path__ + "static/media/icon-home.4cf29cd1.png";